import React, { forwardRef, ReactInstance } from 'react';
import { BillPayTransactionEntity, TransPayEntity } from 'services/openapi';
import PrintThermalInvoice from '../PrintThermalInvoice';

const SelectedThernalVoices = forwardRef(
  (
    {
      selectedInvoices,
      screenOrder = false,
    }: {
      selectedInvoices: TransPayEntity[] | BillPayTransactionEntity[];
      screenOrder?: boolean;
    },
    ref: React.Ref<ReactInstance>,
  ) => {
    return (
      <div ref={ref as any}>
        {/* {selectedInvoices.map((invoice : TransPayEntity) => { */}
        {selectedInvoices?.map((invoice: any) => {
          if (screenOrder) {
            const invoiceData = {
              transaction: {
                transactionCode: invoice?.transactionCode,
                // orderCode: invoice?.orderCode,
                transactionType: invoice?.transactionTypeName,
                payAt: invoice?.updatedAt,
                period: invoice?.customerBill?.billPeriod,
                value: invoice?.customerBill?.billAmount,
                elecProductName: invoice?.customerBill?.elecProductName,
              },
              customer: {
                customerCode: invoice?.customerBill?.customerCode,
                fullName: invoice?.customerBill?.customerName,
                address: invoice?.customerBill?.customerAddress, // TODO: Chua co
              },
              execBy: {
                phoneNumber: invoice?.execPhoneNumber,
                fullName: invoice?.execFullName, // TODO: Chua co
              },
            };

            return (
              <PrintThermalInvoice
                key={invoice.transactionCode}
                data={invoiceData}
              />
            );
          } else {
            const invoiceData = {
              transaction: {
                transactionCode: invoice?.transactionCode,
                orderCode: invoice?.orderCode,
                // transactionType: invoice?.serviceType,
                transactionType: invoice?.transactionType,
                payAt: invoice?.updatedAt,
                period: invoice?.period,
                value: invoice?.paymentAmount,
                elecProductName: invoice?.elecProductName,
              },
              customer: {
                customerCode: invoice?.customerCode,
                fullName: invoice?.customerFullName,
                address: invoice?.customerAddress, // TODO: Chua co
              },
              execBy: {
                phoneNumber: invoice?.execPhoneNumber,
                fullName: invoice?.execFullName, // TODO: Chua co
              },
            };

            return (
              <PrintThermalInvoice
                key={invoice.transactionCode}
                data={invoiceData}
              />
            );
          }
        })}
      </div>
    );
  },
);

export default SelectedThernalVoices;
